(() => {
  if (location.pathname.replace(/\/$/,'') === '/pages/basinda-biz') {
    const pressScript = document.createElement('script');
    pressScript.src = new URL('shg-press.js?v=20260922-2', document.currentScript.src).href;
    document.head.append(pressScript);
  }
  function init() {
    if(document.body.dataset.originalMode==='true')return;
    const path=location.pathname.replace(/\/$/,'');
    if(!path||path==='/preview'||path.startsWith('/__original'))return;
    const main=document.querySelector('main');if(!main)return;
    if(main.querySelector('.shg-pdp-hero')){
      main.querySelectorAll('[data-shg-generated-banner]').forEach(el=>el.remove());
      main.dataset.pageBannerReady='true';document.body.classList.add('shg-inner-page');
      return;
    }
    // Reuse section-owned heroes, including after Shopify replaces a section.
    const existing=main.querySelector('.shg-faq-hero,.shg-ac-hero,.shg-blog-hero,.shg-contact-hero,.shg-shop-banner');
    if(existing){
      main.querySelectorAll('[data-shg-generated-banner]').forEach(el=>el.remove());
      if(!existing.classList.contains('shg-shop-banner')){
        existing.classList.add('shg-page-banner');
        existing.firstElementChild?.classList.add('shg-page-banner-inner');
        existing.querySelector('a')?.classList.add('shg-page-back');
      }
      main.dataset.pageBannerReady='true';document.body.classList.add('shg-inner-page');
      return;
    }
    if(main.querySelector('.shg-page-banner'))return;
    const title=main.querySelector('h1');if(!title)return;
    main.dataset.pageBannerReady='true';document.body.classList.add('shg-inner-page');
    let banner=main.querySelector('.shg-faq-hero,.shg-ac-hero,.shg-blog-hero,.shg-contact-hero');
    if(banner){
      banner.classList.add('shg-page-banner');
      banner.firstElementChild?.classList.add('shg-page-banner-inner');
      banner.querySelector('a')?.classList.add('shg-page-back');
    }else{
      banner=document.createElement('section');banner.className='shg-page-banner';
      banner.dataset.shgGeneratedBanner='true';
      const inner=document.createElement('div');inner.className='shg-page-banner-inner';
      const back=document.createElement('a');back.className='shg-page-back';back.href=main.querySelector('[data-shg-pdp]')?'/collections/all':'/';back.dataset.shgBack='';back.textContent='‹  Geri';
      const heading=document.createElement('h1');heading.textContent=title.textContent.trim();
      inner.append(back,heading);banner.append(inner);
      if(main.classList.contains('preview-page'))main.before(banner);else main.prepend(banner);
      // Product headings remain visible beside the gallery, at the next heading level.
      if(main.querySelector('[data-shg-pdp]')){title.setAttribute('role','heading');title.setAttribute('aria-level','2');}
      else title.hidden=true;
    }
  }
  function editorial() {
    if(document.body.dataset.originalMode==='true'||location.pathname.startsWith('/__original'))return;
    const main=document.querySelector('main');
    if(!main||main.dataset.editorialReady)return;
    const path=location.pathname;
    if(/^\/blogs\/[^/]+\/[^/]+\/?$/.test(path)) {
      const content=main.querySelector('.article__content');
      if(!content)return;
      main.dataset.editorialReady='true';main.classList.add('shg-editorial-article');
      const lead=content.querySelector('p');if(lead)lead.classList.add('shg-article-lead');
      const end=document.createElement('nav');end.className='shg-article-end';end.setAttribute('aria-label','Yazı sonrası bağlantılar');
      const back=document.createElement('a');back.href=path.split('/').slice(0,3).join('/');back.textContent='← Diğer yazıları keşfedin';
      const shop=document.createElement('a');shop.href='/collections/all';shop.textContent='Ürünleri inceleyin →';
      end.append(back,shop);content.append(end);return;
    }
    const isDelivery = /^\/pages\/teslimat-ve-/i.test(path);
    if(!isDelivery&&!/^\/(?:policies\/|pages\/[^/]*(?:politika|sozlesme|sözleşme|kosullar|koşullar))/.test(path))return;
    let roots=[...main.querySelectorAll('.rich-text .card__text')].filter(el=>el.textContent.trim());
    if(!roots.length)roots=[...main.querySelectorAll('.main-page .rte,.shopify-policy__body')].filter(el=>el.textContent.trim());
    roots=roots.filter(el=>!roots.some(other=>other!==el&&other.contains(el)));
    if(!roots.length)return;
    main.dataset.editorialReady='true';
    const layout=document.createElement('div');layout.className='shg-reading-layout';
    const body=document.createElement('article');body.className='shg-reading-body';
    roots.forEach(root=>{
      const section=root.closest('.shopify-section');
      body.append(...root.childNodes);
      if(section)section.hidden=true;
    });
    body.querySelectorAll('h3,h4,.rich-text__title').forEach(old=>{
      const heading=document.createElement('h2');heading.append(...old.childNodes);old.replaceWith(heading);
    });
    if(isDelivery) {
      layout.classList.add('shg-delivery-layout');
      const first = body.firstElementChild;
      if(first && first.tagName !== 'H2') {
        const heading=document.createElement('h2');heading.textContent='Teslimat Bilgileri';body.prepend(heading);
      }
    }
    body.querySelectorAll('p').forEach(p=>{
      const nodes=[...p.childNodes].filter(n=>n.nodeType!==3||n.textContent.trim());
      if(nodes[0]?.nodeName==='STRONG'&&nodes[1]?.nodeName==='BR'){
        const heading=document.createElement('h2');heading.append(...nodes[0].childNodes);nodes[0].remove();nodes[1].remove();p.before(heading);
      }
      if(!p.textContent.trim()&&!p.querySelector('img,iframe'))p.remove();
    });
    const headings=[...body.querySelectorAll('h2,h3,h4')];
    if(headings.length){
      const aside=document.createElement('aside');aside.className='shg-reading-aside';
      const details=document.createElement('details');details.open=matchMedia('(min-width: 801px)').matches;
      const summary=document.createElement('summary');summary.textContent='Bu sayfada';
      const nav=document.createElement('nav');nav.setAttribute('aria-label','Sayfa bölümleri');
      headings.forEach((h,i)=>{h.id=h.id||`shg-reading-section-${i+1}`;const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent.trim();nav.append(a);});
      details.append(summary,nav);aside.append(details);layout.append(aside);
    }else layout.classList.add('shg-reading-layout--single');
    layout.append(body);main.append(layout);
  }
  document.addEventListener('click',event=>{
    const back=event.target.closest('a[data-shg-back],a.shg-page-back');
    if(!back||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    if(!document.referrer)return;
    let previous;
    try{previous=new URL(document.referrer);}catch{return;}
    if(previous.origin!==location.origin||previous.href===location.href||history.length<2)return;
    event.preventDefault();
    history.back();
  });
  function ready(){init();editorial();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
  document.addEventListener('shopify:section:load',init);
})();
